import { __extends } from "tslib";
import { generateTextShadow, getShadowElement, Platform, removeClass } from '@tyler-components-web/core';
import { BaseAdapter } from '../core/adapters/base-adapter';
import { PRODUCT_ICON_CONSTANTS } from './product-icon-constants';
var ProductIconAdapter = /** @class */ (function (_super) {
    __extends(ProductIconAdapter, _super);
    function ProductIconAdapter(component) {
        var _this = _super.call(this, component) || this;
        _this._backgroundElement = getShadowElement(component, PRODUCT_ICON_CONSTANTS.selectors.PRODUCT_ICON_BACKGROUND);
        _this._iconElement = getShadowElement(component, PRODUCT_ICON_CONSTANTS.selectors.PRODUCT_ICON);
        _this._textElement = getShadowElement(component, PRODUCT_ICON_CONSTANTS.selectors.PRODUCT_TEXT);
        return _this;
    }
    ProductIconAdapter.prototype.setBackgroundColor = function (color) {
        this._backgroundElement.style.backgroundColor = color;
    };
    ProductIconAdapter.prototype.setIconColor = function (color) {
        this._iconElement.style.color = color;
        this._textElement.style.color = color;
    };
    ProductIconAdapter.prototype.setElementSize = function (value) {
        this._backgroundElement.style.height = value + "px";
        this._backgroundElement.style.width = value + "px";
    };
    ProductIconAdapter.prototype.setFontSize = function (value) {
        var textFontSize = value * PRODUCT_ICON_CONSTANTS.numbers.TEXT_FONT_SIZE_MODIFIER;
        var iconFontSize = value * PRODUCT_ICON_CONSTANTS.numbers.ICON_FONT_SIZE_MODIFIER;
        if (Platform.TRIDENT) {
            this._iconElement.style.fontSize = iconFontSize + "px";
            this._textElement.style.fontSize = textFontSize + "px";
        }
        else {
            this._iconElement.style.setProperty('--tyl-product-icon-font-size', iconFontSize + "px");
            this._textElement.style.setProperty('--tyl-product-icon-font-size', textFontSize + "px");
            this._iconElement.style.fontSize = "var(--tyl-product-icon-font-size, " + iconFontSize + "px)";
            this._textElement.style.fontSize = "var(--tyl-product-icon-font-size, " + textFontSize + "px)";
        }
    };
    ProductIconAdapter.prototype.removeIconClass = function (classes) {
        removeClass(classes, this._iconElement);
        removeClass(classes, this._textElement);
    };
    ProductIconAdapter.prototype.setTextShadow = function (hasShadow, iterations, shadowColor) {
        if (hasShadow) {
            var shadow = generateTextShadow(iterations, shadowColor);
            this._iconElement.style.textShadow = shadow;
            this._textElement.style.textShadow = shadow;
        }
        else {
            this._iconElement.style.removeProperty('text-shadow');
            this._textElement.style.removeProperty('text-shadow');
        }
    };
    return ProductIconAdapter;
}(BaseAdapter));
export { ProductIconAdapter };
